import type { IconName } from '@/icons/names';

/** Settings section id → icon name. Reuses existing registry icons; adds 6 in Task 1. */
export const sectionIcons: Record<string, IconName> = {
  account: 'user',
  privacy: 'shield',
  notifications: 'bell',
  appearance: 'palette',
  sound: 'volume-2',
  content: 'sliders-horizontal',
  data: 'database',
  connected: 'link',
  language: 'globe',
  accessibility: 'accessibility',
  about: 'file-text',
};
